import React, { useEffect, useState } from 'react';
import { brand, nav, launch } from '../mock/data';
import { ArrowUpRight } from 'lucide-react';

const useLondonTime = () => {
  const [time, setTime] = useState('');
  useEffect(() => {
    const tick = () => {
      try {
        setTime(new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Los_Angeles' }).format(new Date()));
      } catch (e) { setTime(''); }
    };
    tick();
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, []);
  return time;
};

const Footer = () => {
  const time = useLondonTime();
  return (
    <footer className="relative bg-[var(--ink)] text-white overflow-hidden">
      <div className="max-frame container-px py-24 md:py-32">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12">
          <div>
            <p className="text-[11px] uppercase tracking-kicker text-white/55 mb-6">Halloween drop · Delivery Oct 26 · In-store + delivery Oct 30</p>
            <h2 className="font-display uppercase font-tight text-[clamp(2.6rem,7vw,6rem)] leading-[0.92]">
              Get the<br />
              <span className="text-[var(--accent-soft)]">Lotus Bundle</span>
            </h2>
            <p className="mt-5 text-white/55 max-w-[420px]">{launch.bundleNote}</p>
          </div>
          <a
            href={brand.dealsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 self-start rounded-full bg-white text-[var(--ink)] px-8 py-4 text-[13px] uppercase tracking-[0.12em] font-semibold hover:bg-[var(--accent-soft)] hover:text-white transition-colors"
          >
            Shop the deals
            <ArrowUpRight size={16} />
          </a>
        </div>
      </div>

      <div className="max-frame container-px py-10 border-t border-white/12 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div className="flex items-center gap-3">
          <img src={brand.marks.lotusLight} alt="Lotus" className="h-9 w-auto" />
          <div className="leading-tight">
            <span className="font-display text-2xl tracking-wide block">PL16</span>
            <span className="text-[11px] uppercase tracking-[0.14em] text-white/55">{brand.full}</span>
          </div>
        </div>

        <nav className="flex flex-wrap items-center gap-x-8 gap-y-3">
          {nav.map((n) => (
            <a key={n.label} href={n.href} className="text-[12px] uppercase tracking-[0.14em] text-white/60 hover:text-white transition-colors">
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-6 text-[12px] uppercase tracking-[0.14em] text-white/60">
          <span>{brand.city}</span>
          <span className="text-white">{time}</span>
        </div>
      </div>

      <div className="max-frame container-px pb-8 text-[11px] uppercase tracking-[0.12em] text-white/35 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <span>© {new Date().getFullYear()} PL16 · Lotus 16th Anniversary · Limited Edition</span>
        <span data-testid="license-number">License No. C100000241</span>
      </div>
    </footer>
  );
};

export default Footer;
